document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".icon-chevron-top").forEach(function (icon) {
        icon.addEventListener("click", function (e) {
            e.preventDefault(); // hindra att länken triggas
            const li = icon.closest("li");
            if (li) {
                li.classList.toggle("open");
            }
        });
    });

    // Sub-nav items with no real destination (href="#") open their
    // dropdown when the link itself is clicked, not just the arrow icon.
    document.querySelectorAll(".sub-nav__item--hash-link > .sub-nav__item-inner > a").forEach(function (link) {
        link.addEventListener("click", function (e) {
            e.preventDefault();
            const li = link.closest("li");
            if (li) {
                li.classList.toggle("open");
            }
        });
    });


    var mobileLang = document.querySelector('.sec-menu .weglot-parent-menu-item a');

    if (mobileLang) {
        mobileLang.addEventListener("click", function (e) {
            e.preventDefault(); // stoppar länkens default-beteende

            const li = mobileLang.closest("li");
            const submenu = li ? li.querySelector(".sub-menu") : null;

            if (li) {
                li.classList.toggle("active");
            }
            if (submenu) {
                submenu.classList.toggle("open");
            }
        });
    }

});


//# sourceMappingURL=submenu-open.js.map
